import React from 'react';
import Flagship from '../../core/flagship';
import Field from '../records/Field';
import {connect} from 'react-redux';
import { Loader, Header, Grid, Modal, Button, Icon } from 'semantic-ui-react';
import {shouldShowField, empty} from '../../utils/helpers';

class LineItemEditModal extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.editName = this.editName.bind(this);
        this.saveAndExit = this.saveAndExit.bind(this);
        this.getLineItemForm = this.getLineItemForm.bind(this);
        this.getFormSubService = this.getFormSubService.bind(this);
        this.getSubServiceFields = this.getSubServiceFields.bind(this);

    }

    getInitialState() {
        return {
            loading:true,
            id: this.props.lineItemId,
            line_item_key: '',
            line_item_name: '',
            line_item_type: '',
            parent_rfp: 0,
            vendor: '',
            cogs: '',
            price: '',
            errors: [],
            lineItemData: [],
            lineItemForm: [],
            originalLineItemData: [],
            changed: false
        };
    }

    componentDidMount() {
        // Get Form
        this.getLineItemForm();
    }


    getLineItemForm() {

        let self = this;
        let service = this.props.lineItem.line_item_type;

        let mainService = false;
        let subService = false;

        Flagship.config.lineItemServices.map(function(element) {
            if (element.value === service) {
                mainService = service;
            } else if (element.hasOwnProperty("subOptions")) {
                element.subOptions.map(function(subItem) {
                    if (subItem.value === service) {
                        mainService = element.value;
                        subService = service;
                    }
                })
            }
        });

        if (subService !== false) {
            // If dealing with a sub-service, get both levels of fields

            this.getFormSubService(mainService, subService);
        } else {


            Flagship.get(
                'line-item-form/' + mainService,
                {
                    withData: (typeof this.props.lineItemId === "undefined" ? false : this.props.lineItemId)
                },
                function (response) {

                    if (response.data.success === true) {

                        self.setState({
                            loading: false,
                            lineItemData: response.data.fieldData,
                            originalLineItemData: response.data.fieldData,
                            lineItemForm: response.data.results
                        });



                    } else {

                        Flagship.error(
                            "Error getting line item form from Flagship API server.",
                            self.props.recordId,
                            self.props.userId
                        );
                    }
                },
                function (err) {

                    Flagship.error(
                        "Error getting line item form from Flagship API server: " + err,
                        self.props.recordId,
                        self.props.userId
                    );
                }
            );
        }
    }

    getFormSubService(mainService, subService) {

        let self = this;

        // First get main service fields
        Flagship.get(
            'line-item-form/' + mainService,
            {
                withData: (typeof this.props.lineItemId === "undefined" ? false : this.props.lineItemId)
            },
            function (response) {

                if (response.data.success === true) {
                    self.setState({
                        lineItemForm: response.data.results,
                        lineItemData: response.data.fieldData,
                        originalLineItemData: response.data.fieldData
                    }, function () {
                        self.getSubServiceFields(subService);
                    });

                } else {

                    Flagship.error(
                        "Error getting line item form from Flagship API server.",
                        self.props.recordId,
                        self.props.userId
                    );
                }
            },
            function (err) {

                Flagship.error(
                    "Error getting line item form from Flagship API server: " + err,
                    self.props.recordId,
                    self.props.userId
                );
            }
        );
    }

    getSubServiceFields(subService) {

        let self = this;

        // Now add sub service fields
        Flagship.get(
            'line-item-form/' + subService,
            {},
            function (response) {

                if (response.data.success === true) {

                    let combinedForm = [...self.state.lineItemForm, ...response.data.results];

                    combinedForm.sort(function(a,b) {return (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0);} );

                    self.setState({
                        lineItemForm: combinedForm,
                        loading:false,
                    });

                } else {

                    Flagship.error(
                        "Error getting line item form from Flagship API server.",
                        self.props.recordId,
                        self.props.userId
                    );
                }
            },
            function (err) {

                Flagship.error(
                    "Error getting line item form from Flagship API server: " + err,
                    self.props.recordId,
                    self.props.userId
                );
            }
        );
    }



    addError(fieldId) {

        let errors = this.state.errors;

        if (errors.indexOf(fieldId) === -1) {
            errors.push(fieldId);
        }

        this.setState({
            errors: errors
        });
    }

    clearError(fieldId) {

        let errors = this.state.errors;
        for (var i = errors.length - 1; i >= 0; i--) {
            if (errors[i] === fieldId) {
                errors.splice(i, 1);
            }
        }

        this.setState({
            errors: errors
        });
    }

    onChange(e, data, field) {
        let newLineItemData = Object.assign({}, this.state.lineItemData);
        newLineItemData[field] = data;

        this.setState({
            changed: true,
            lineItemData: newLineItemData
        });

    }

    editName() {
        this.setState({
            editingName: true
        });
    }

    saveAndExit() {
        let self = this;
        Flagship.post(
            "line-item/update/" + self.props.lineItemId,
            {
                data: self.state.lineItemData
            },
            function(response) {
                if (response.data.success === true) {

                    Flagship.event(
                        "update-line-item",
                        {
                            lineItemId: self.props.lineItemId,
                            lineItemKey: self.props.lineItem.line_item_key,
                            lineItemName: self.props.lineItem.line_item_name,
                            lineItemType: self.props.lineItem.line_item_type,
                            oldData: self.state.originalLineItemData,
                            newData: self.state.lineItemData
                        },
                        self.props.recordId,
                        self.props.userId
                    );
                    Flagship.notify("Line item updated.");
                    self.setState(self.getInitialState(), function() {

                        if (typeof self.props.onUpdateLineItem === "function") {
                            self.props.onUpdateLineItem();
                        }
                    });
                } else {
                    Flagship.error("Error updating line item.", self.props.recordId, self.props.userId);
                }
            }, function(err) {
                Flagship.error("Error updating line item: " + err, self.props.recordId, self.props.userId);
            }
        );
    }


    render() {

        if( this.state.loading === true ) {
            return (
                <Loader />
            );

        } else {

            let self = this;

            return (
                <Modal
                    open={this.props.open}
                    onClose={this.props.cancelUpdate}
                    closeIcon
                >
                    {this.state.changed === false ?
                    <Button floated="right" className="view-edit-line-item" onClick={this.props.swapToView}>
                        <Icon name="eye"/>
                        View Line Item
                    </Button>
                        :
                        <span className="line-item-modified float-right">
                            Modified
                        </span>
                    }
                    <Header icon="pin" content={this.props.lineItem.line_item_key + ' - ' + this.props.lineItem.line_item_name}/>
                    <Modal.Content>
                        <div>
                            <Grid>
                                <Grid.Column width={16}>
                                    <Header as="h3">Edit Line Item Info</Header>
                                    {this.state.lineItemForm.map(function(item, i) {

                                        let value = !empty(self.state.lineItemData) && self.state.lineItemData.hasOwnProperty(item.field_id) ? self.state.lineItemData[item.field_id] : '';

                                        return( shouldShowField( item, self.state.lineItemData) ?
                                                <Field
                                                    contentType="lineItem"
                                                    addError={self.addError.bind(self)}
                                                    clearError={self.clearError.bind(self)}
                                                    model={"LineItem." + i}
                                                    key={'field-' + i}
                                                    value={value}
                                                    default={item.default}
                                                    filterInput={item.validation !== '' ? item.validation : null}
                                                    onChange={(e, data, fieldId) => self.onChange(e, data, fieldId, i)}
                                                    {...item} />
                                                : null
                                        );
                                    })}
                                </Grid.Column>
                            </Grid>
                        </div>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button primary onClick={this.saveAndExit}>
                            <Icon name='plus' /> Update Line Item
                        </Button>
                        <Button color='grey' onClick={this.props.cancelUpdate}>
                            <Icon name='dont' /> Cancel
                        </Button>
                    </Modal.Actions>
                </Modal>


            );

        }
    }
}

function mapStateToProps(state) {
    return {
        username: state.main.username,
        userId: state.main.userId,
        userRole: state.main.userRole
    };
}

export default connect(
    mapStateToProps,
    null
)(LineItemEditModal);


// WEBPACK FOOTER //
// ./src/components/modals/LineItemEditModal.js